export enum FileSortFields {
    NAME = 'name',
    SIZE = 'size',
    CREATED_AT = 'date'
}